/* src/app/components/app-restore-password-modal/app-restore-password-modal.component.scss */
.wrapper {
  width: 90%;
  margin: 15px auto;
}
h3 {
  margin-top: 15px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  font-size: 16px;
}
ion-input {
  --padding-start: 10px !important;
}
ion-item {
  --border-width: 1px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
}
.cross {
  cursor: pointer;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.cross ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.cross:hover {
  background: #f2dbd9;
}
.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 12px;
}
.button-block ion-button {
  width: 100%;
  min-height: 40px;
  --background: #F48B7F;
  color: white;
  font-size: 14px;
}
.button-block ion-button:hover {
  --background: #FC5E07 !important;
}
ion-icon {
  z-index: 10;
}
span {
  margin: 10px 0;
}
.email-msg {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 0 0 8px;
  font-size: 14px;
}
/*# sourceMappingURL=app-restore-password-modal.component.css.map */
